export const cardsData = [{
    "_id": "62e8dcc60f36fd001fe0d624",
    "url": "https://ueclub.kingdee.com/p/62e8dcc60f36fd001fe0d624?articleType=591e5fb0d82529145405981f",
    "title": "品牌认知调研",
    "main": "品牌认知度是品牌资产的重要组成部分，它是衡量消费者对品牌内涵及价值的认识和理解度的标准。品牌认知是公司竞争力的一种体现，有时会成为一种核心竞争力。",
    "list": ["①打破产品同质化的手段之一", "②进行品牌定位"],
    "tags": [
        "市场推广",
        "品牌管理"
    ],
    "search": ["验证"],
    "position": ["市场推广", "品牌管理"],
    "journey": ["市场活动", "续约", "增购"],
    "IPD": ["持续运营"]
}, {
    "_id": "6332918078b3e8001fa1b868",
    "url": "https://ueclub.kingdee.com/p/6332918078b3e8001fa1b868?articleType=591e5fb0d82529145405981f",
    "title": "企业数字化成熟度测评",
    "main": "数字化能力成熟度评估，将有助于帮助企业厘清当前所处的数字化位置，并对数字化转型的路径有个清晰的认知，为后续制定适合企业的数字化转型战略和可行的行动计划提供参考和决策依据。",
    "list": ["①通过企业数字化成熟度测评，获取商机信息", "②获取潜在客户数字化转型现状、所面临的难点、痛点、转型诉求等，为后续商机跟进提供参考。"],
    "tags": [
        "市场推广"
    ],
    "search": ["验证"],
    "position": ["市场推广"],
    "journey": ["咨询", "市场活动", "体验/试用"],
    "IPD": ["持续运营"]
}, {
    "_id": "6332920478b3e8001fa1b86a",
    "url": "https://ueclub.kingdee.com/p/6332920478b3e8001fa1b86a?articleType=591e5fb0d82529145405981f",
    "title": "自助实施能力测评",
    "main": "适用于小微产品，帮助小微企业厘清当前企业自助完成实施的能力水平，为实施服务的选择提供参考和决策依据。",
    "list": ["①帮助实施人员充分了解客户完成实施的能力水平，有侧重地提供实施服务", "②帮助产品经理/产品设计了解客户在实施环节主要面临的问题，促进产品的优化，降低产品的实施难度。"],
    "tags": ["产品经理", "产品设计", "实施项目管理"],
    "search": ["验证"],
    "position": ["产品经理", "产品设计", "实施项目管理"],
    "journey": ["环境开通"],
    "IPD": ["持续运维"]
}, {
    "_id": "633292db78b3e8001fa1b86c",
    "url": "https://ueclub.kingdee.com/p/633292db78b3e8001fa1b86c?articleType=591e5fb0d82529145405981f",
    "title": "细分行业研究",
    "main": "通过研究帮助产品团队收集行业研究数据，了解行业发展状态与趋势（政策、技术、产业链条上主要参与者、用户群体特征等），发现行业机会。",
    "list": [],
    "tags": ["产品经理", "产品设计", "业务架构"],
    "search": ["探索"],
    "position": ["产品经理", "产品设计", "业务架构"],
    "journey": ["产品使用"],
    "IPD": ["持续规划"]
}, {
    "_id": "6332938178b3e8001fa1b86e",
    "url": "https://ueclub.kingdee.com/p/6332938178b3e8001fa1b86e?articleType=591e5fb0d82529145405981f",
    "title": "竞品分析-产品研究",
    "main": "通过分析竞品的相关信息（目标人群、主要功能、发展模式等），了解当前市场发展状况，找准产品定位，明确规划方向",
    "list": [],
    "tags": ["产品经理", "产品设计"],
    "search": ["探索"],
    "position": ["产品经理", "产品设计"],
    "journey": ["产品使用"],
    "IPD": ["持续规划"]
}, {
    "_id": "6332952b78b3e8001fa1b86f",
    "url": "https://ueclub.kingdee.com/p/6332952b78b3e8001fa1b86f?articleType=591e5fb0d82529145405981f",
    "title": "竞品分析-界面体验",
    "main": "通过分析竞品的功能、内容、信息架构、交互设计、色彩、语言风格等特点，为产品的界面设计提供思路借鉴。",
    "list": [],
    "tags": ["产品经理", "产品设计", "UI设计"],
    "search": ["探索"],
    "position": ["产品经理", "产品设计", "UI设计"],
    "journey": ["产品使用"],
    "IPD": ["持续规划"]
}, {
    "_id": "6332961378b3e8001fa1b872",
    "url": "https://ueclub.kingdee.com/p/6332961378b3e8001fa1b872?articleType=591e5fb0d82529145405981f",
    "title": "用户需求调研（定量）",
    "main": "通过研究帮助产品团队收集用户数据，了解目标用户的群体特征、核心诉求、价值偏好等信息，为产品规划提供数据支撑。",
    "list": ["①获取用户（客户）的核心诉求、期望；", "②获取用户（客户）的使用反馈；"],
    "tags": ["产品经理", "产品设计"],
    "search": ["探索"],
    "position": ["产品经理", "产品设计"],
    "journey": ["产品使用"],
    "IPD": ["持续规划"]
}, {
    "_id": "6332967778b3e8001fa1b873",
    "url": "https://ueclub.kingdee.com/p/6332967778b3e8001fa1b873?articleType=%5Bobject%20Object%5D",
    "title": "用户需求调研（定性）",
    "main": "可结合产品团队的改版设想，对不同使用偏好和不同使用程度的用户进行用户访谈，以了解用户的使用动机、使用习惯、操作路径、使用痛点、对产品的心理预期，进而将产品改版的设想与用户需求进行平衡，给到专业的产品改版评估意见和建议。",
    "list": ["①获取用户（客户）的核心诉求、期望及其动机；", "②获取用户（客户）的使用反馈、痛点；"],
    "tags": ["产品经理", "产品设计"],
    "search": ["探索"],
    "position": ["产品经理", "产品设计"],
    "journey": ["产品使用"],
    "IPD": ["持续规划"]
}, {
    "_id": "6332972678b3e8001fa1b874",
    "url": "https://ueclub.kingdee.com/p/6332972678b3e8001fa1b874?articleType=591e5fb0d82529145405981f",
    "title": "用户角色画像",
    "main": "用户角色画像是一种勾画用户、联系用户诉求与设计方向的有效工具。通过研究手段创造一系列“典型”或“象征性”的用户，以浅显和贴近生活的话语将用户属性，行动与期待联系起来。",
    "list": ["①帮助产品团队统一对用户的认识，将焦点关注在目标用户的动机和行为上进行设计，辅助产品设计开发。"],
    "tags": ["产品经理", "产品设计"],
    "search": ["探索"],
    "position": ["产品经理", "产品设计"],
    "journey": ["产品使用"],
    "IPD": ["持续规划"]
}, {
    "_id": "6332977378b3e8001fa1b875",
    "url": "https://ueclub.kingdee.com/p/6332977378b3e8001fa1b875?articleType=591e5fb0d82529145405981f",
    "title": "用户体验地图",
    "main": "以视觉化的方式表示用户（第一人称视角）的图，以叙述故事的方式来描述用户与产品、服务、系统交互时的体验和关系，以此来帮助理解用户需求和寻找用户痛点。",
    "list": ["①帮助研发团队以“用户视角”、全局化思考产品体验问题；", "②帮助团队内部对体验问题充分达成共识，高效推进项目;"],
    "tags": ["产品经理", "产品设计"],
    "search": ["探索"],
    "position": ["产品经理", "产品设计"],
    "journey": ["产品使用"],
    "IPD": ["持续规划"]
}, {
    "_id": "633297c578b3e8001fa1b876",
    "url": "https://ueclub.kingdee.com/p/633297c578b3e8001fa1b876",
    "title": "产品概念测试（定量）",
    "main": "在新产品开发的产品概念阶段，对该产品可能会提出很多个细化的概念方向。通过产品概念验证，获取目标用户对概念的反应，发现概念中存在的不足，为产品规划提供用户侧证据。",
    "list": ["①帮助产品团队修改和充实产品概念的内容；", "②帮助产品团队验证最符合用户需求的产品；"],
    "tags": ["产品经理", "产品设计"],
    "search": ["验证"],
    "position": ["产品经理", "产品设计"],
    "journey": ["产品使用"],
    "IPD": ["持续规划"]
}, {
    "_id": "6332981578b3e8001fa1b877",
    "url": "https://ueclub.kingdee.com/p/6332981578b3e8001fa1b877?articleType=591e5fb0d82529145405981f",
    "title": "产品概念测试（定性）",
    "main": "可结合产品团队规划初期的设想，对目标用户进行访谈，重点了解目标用户对产品细化的概念或功能的感兴趣/不感兴趣的原因，为产品规划提供用户侧证据。",
    "list": ["①帮助产品团队修改和充实产品概念的内容；", "②帮助产品团队验证最符合用户需求的产品；"],
    "tags": ["产品经理", "产品设计"],
    "search": ["验证"],
    "position": ["产品经理", "产品设计"],
    "journey": ["产品使用"],
    "IPD": ["持续规划"]
}, {
    "_id": "6332a5a778b3e8001fa1b87c",
    "url": "https://ueclub.kingdee.com/p/6332a5a778b3e8001fa1b87c?articleType=591e5fb0d82529145405981f",
    "title": "界面接受度测试",
    "main": "界面接受度测试是产品设计研发过程的重要组成部分，在进入开发前，将界面设计稿面向真实用户进行验证，能够快速发现和修复潜在的可用性问题，降低试错成本。其意义还包括：",
    "list": ["①第一时间获取用户反馈；", "②发现潜在的创新机会；"],
    "tags": ["产品经理", "产品设计", "UI设计"],
    "search": ["验证"],
    "position": ["产品经理", "产品设计", "UI设计"],
    "journey": ["产品使用"],
    "IPD": ["持续规划"]
}, {
    "_id": "6332a95a78b3e8001fa1b87e",
    "url": "https://ueclub.kingdee.com/p/6332a95a78b3e8001fa1b87e?articleType=591e5fb0d82529145405981f",
    "title": "产品体验专家评估",
    "main": "邀请专家对产品界面进行走查，能够快速发现可用性问题，评估体验差距。与用户测试相比，专家评估效率更高，成本更低，操作也更加灵活方便。其意义还包括：",
    "list": ["①无需与用户参与即可识别体验问题；", "②向设计师/产品经理提供更快速且廉价的反馈；"],
    "tags": ["产品经理", "产品设计"],
    "search": ["验证"],
    "position": ["产品经理", "产品设计"],
    "journey": ["产品使用"],
    "IPD": ["持续开发"]
}, {
    "url": "/usability",
    "title": "产品体验可用性测试",
    "main": "作为产品发版前的一项重要工作，可用性测试邀请真实目标用户浏览并使用产品。通过可用性测试，不仅能够了解用户能否完成指定任务，还可以收集用户满意度及操作反馈，利用真实的用户意见优化并改进产品。",
    "list": ["①发现可用性问题并快速解决；", "②提升产品的市场接受度；"],
    "tags": ["产品经理", "产品设计"],
    "search": ["验证"],
    "position": ["产品经理", "产品设计"],
    "journey": ["产品使用"],
    "IPD": ["持续开发"]
}, {
    "_id": "6332ad4778b3e8001fa1b883",
    "url": "https://ueclub.kingdee.com/p/6332ad4778b3e8001fa1b883?articleType=591e5fb0d82529145405981f",
    "title": "产品使用问题反馈",
    "main": "产品使用问题反馈可以帮助产品经理及运营人员更好地了解用户需求，发现并识别问题，改进产品及服务，从而提升客户满意度和忠诚度，是收集客户问题和期望的重要手段。其主要优势包括：",
    "list": ["①了解用户需求，获得有价值的洞察；", "②做出更好的决策，优化产品及服务；"],
    "tags": ["产品经理", "产品设计", "产品运营"],
    "search": ["探索"],
    "position": ["产品经理", "产品设计", "产品运营"],
    "journey": ["社区自助", "反馈与获取支持"],
    "IPD": ["持续运营"]
}, {
    "_id": "6332ae3178b3e8001fa1b885",
    "url": "https://ueclub.kingdee.com/p/6332ae3178b3e8001fa1b885?articleType=591e5fb0d82529145405981f",
    "title": "官网体验满意度",
    "main": "官网是潜在客户前期了解产品的关键信息渠道，不仅影响着用户心中的品牌形象，同时对后续的成交转化也发挥着重要作用。官网体验满意度调研能够有效了解目标用户对官网的评价和反馈，从而有针对性地作出改进，提升品牌满意度和忠诚度。其优势还包括：",
    "list": ["①收集用户评价与反馈；", "②发现可能的优化点；"],
    "tags": ["产品运营"],
    "search": ["验证"],
    "position": ["产品运营"],
    "journey": ["关注", "搜索", "咨询"],
    "IPD": ["持续运营"]
}, {
    "_id": "6332af5378b3e8001fa1b887",
    "url": "https://ueclub.kingdee.com/p/6332af5378b3e8001fa1b887?articleType=591e5fb0d82529145405981f",
    "title": "产品试用满意度",
    "main": "产品试用满意度调研能够收集潜在客户在体验/试用阶段的评价与反馈，有针对性地优化产品及服务设计，进而提升产品成交转化率。",
    "list": [],
    "tags": ["产品经理", "产品设计", "产品运营"],
    "search": ["验证"],
    "position": ["产品经理", "产品设计", "产品运营"],
    "journey": ["体验/试用"],
    "IPD": ["持续运营"]
}, {
    "_id": "6332b1e578b3e8001fa1b888",
    "url": "https://ueclub.kingdee.com/p/6332b1e578b3e8001fa1b888?articleType=591e5fb0d82529145405981f",
    "title": "实施服务满意度",
    "main": "了解客户对实施阶段服务的满意度和评价，能够帮助实施交付人员识别项目工作中存在的不足和欠缺之处，从而改进服务内容和流程，提升实施服务质量。",
    "list": [],
    "tags": ["实施项目管理", "实施顾问", "交付管理"],
    "search": ["验证"],
    "position": ["实施项目管理", "实施顾问", "交付管理"],
    "journey": ["上线运行"],
    "IPD": ["持续运营"]
}, {
    "_id": "6332b33b78b3e8001fa1b889",
    "url": "https://ueclub.kingdee.com/p/6332b33b78b3e8001fa1b889?articleType=591e5fb0d82529145405981f",
    "title": "产品满意度调研",
    "main": "作为最常见的调研方法之一，产品满意度调研能够衡量产品体验满足客户期望的程度，通过准确直观的数据反映业务健康状况。它是衡量客户忠诚度的重要指标，良好的满意度得分意味着更高客户留存率，更长的生命周期价值和更强的品牌声誉。其主要优势还在于：",
    "list": ["①提升客户忠诚度；", "②推动业务和产品做出更优的决策；"],
    "tags": ["产品经理", "产品设计", "产品运营"],
    "search": ["验证"],
    "position": ["产品经理", "产品设计", "产品运营"],
    "journey": ["产品使用"],
    "IPD": ["持续运营"]
}, {
    "_id": "6332b96eb94168002338cb15",
    "url": "https://ueclub.kingdee.com/p/6332b96eb94168002338cb15",
    "title": "产品运营诊断（定性）",
    "main": "通过邀请相关参与者对产品运营中遇到的问题进行评价和反馈，定位问题发生的原因，明确业务场景及用户需求，验证运营方案接受度，从而为产品运营策略的制定提供真实可靠的基础。其价值意义还包括：",
    "list": ["①提供深入细致的用户洞察；", "②推动运营人员作出更有价值的决策；"],
    "tags": ["产品经理", "产品设计", "产品运营"],
    "search": ["验证"],
    "position": ["产品经理", "产品设计", "产品运营"],
    "journey": ["产品使用", "社区自助"],
    "IPD": ["持续运营"]
}, {
    "_id": "6332ba70b94168002338cb17",
    "url": "https://ueclub.kingdee.com/p/6332ba70b94168002338cb17?articleType=591e5fb0d82529145405981f",
    "title": "产品运营诊断（定量）",
    "main": "利用问卷的形式收集用户在产品运营方面的意见建议，通过直观准确的数据展现用户满意度、运营方案在用户侧的接受度等，为运营决策的制定提供及时有效的一手资料。其优势主要有：",
    "list": ["①通过直观的数据展现用户意见；", "②推动运营人员做出科学决策；"],
    "tags": ["产品经理", "产品设计", "产品运营"],
    "search": ["验证"],
    "position": ["产品经理", "产品设计", "产品运营"],
    "journey": ["产品使用", "社区自助"],
    "IPD": ["持续运营"]
}, {
    "_id": "6332bb96b94168002338cb19",
    "url": "https://ueclub.kingdee.com/p/6332bb96b94168002338cb19?articleType=591e5fb0d82529145405981f",
    "title": "服务费力度调研",
    "main": "服务费力度可以衡量客户在使用服务查找信息或解决问题时所付出的努力程度。作为服务满意度的扩充，服务费力度能够更加充分地评估用户在服务体验阶段的情况。其主要优势包括：",
    "list": ["①易操作，适用于所有面向客户的流程；", "②较高的可行性和针对性；"],
    "tags": ["技术支持", "产品运营"],
    "search": ["验证"],
    "position": ["技术支持", "产品运营"],
    "journey": ["反馈与获取支持", "社区自助"],
    "IPD": ["持续反馈"]
}, {
    "_id": "6332bc35b94168002338cb1a",
    "url": "https://ueclub.kingdee.com/p/6332bc35b94168002338cb1a?articleType=591e5fb0d82529145405981f",
    "title": "忠诚度NPS",
    "main": "NPS是衡量客户忠诚度的重要指标，它可以直观地反映出客户对产品或服务的认可程度和购买意愿，在一定程度上预测企业为未来发展趋势和持续盈利的能力。其主要优势还包括：",
    "list": ["①操作简单，成本低廉，响应率高；", "②着眼于客户与企业间的整体关系，是衡量公司发展的重要指标；"],
    "tags": ["品牌管理", "产品运营"],
    "search": ["验证"],
    "position": ["品牌管理", "产品运营"],
    "journey": ["续约", "增购"],
    "IPD": ["持续运营"]
}]